<template>
    <v-data-table
        :headers="registrySchemaHeaders"
        :items="registrySchemas"
        item-key="id"
        class="elevation-1"
        :items-per-page="25"
        :search="search"
    >
        <template v-slot:item.type="{ item }">
            <v-chip :color="getChipColor(item)">
                {{ getType(item) }}
            </v-chip>
        </template>
        <template v-slot:item.view="{ item }">
            <v-row>
                <v-icon @click="viewRegistrySchemaItems(item)">$bookshelf</v-icon>
            </v-row>
        </template>
        <template v-slot:item.edit="{ item }">
            <v-row>
                <v-icon @click="editRegistrySchema(item)">$eye</v-icon>
            </v-row>
        </template>
    </v-data-table>
</template>
<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import { SavedRegistrySchema } from "@/services/registries/registriesAPI";
import { VDataTableHeader } from "@/vuetifyTypeFixes";

const router = useRouter();

const { registrySchemas } = defineProps<{
    registrySchemas: SavedRegistrySchema[],
    search: string;
}>();

const registrySchemaHeaders = ref<VDataTableHeader[]>([
    {
        title: "Display Name",
        value: "displayName",
        sortable: true,
        align: "start",
        width: "40%",
    },
    {
        title: "Name",
        value: "name",
        sortable: true,
        align: "start",
        width: "20%",
    },
    {
        title: "Type",
        value: "type",
        sortable: true,
        align: "start",
        width: "15%",
    },
    {
        title: "View Entries",
        value: "view",
        sortable: true,
        align: "start",
        width: "10%",
    },
    {
        title: "View Schema",
        value: "edit",
        sortable: true,
        align: "start",
        width: "10%",
    },
]);

function getType(schema: SavedRegistrySchema): string {
    if (schema.isBenchlingDropdown) {
        return "Benchling Dropdown";
    } else if (schema.isBenchling) {
        return "Benchling Registry"
    } else {
        return "Invaio Registry"
    }
}

function getChipColor(schema: SavedRegistrySchema): string {
    if (schema.isBenchlingDropdown) {
        return "warning";
    } else if (schema.isBenchling) {
        return "blue"
    } else {
        return "green";
    }
}

function viewRegistrySchemaItems(registrySchema: SavedRegistrySchema) {
    router.push({ path: `/registries/entries/${registrySchema.name}` });
}

function editRegistrySchema(registrySchema: SavedRegistrySchema) {
    router.push({ path: `/registries/view/${registrySchema.name}` });
}

</script>
